import { useState } from 'react';
import { MenuChildItemInterface } from 'utils/types/oraclePayment/MenuItem';

interface UseViewModelProps {
  subItems?: MenuChildItemInterface[];
}

const useViewModel = ({ subItems }: UseViewModelProps) => {
  const [isShowCondiments, setShowCondiments] = useState(true);

  const showCondiments = () => {
    if (subItems?.length) {
      setShowCondiments(!isShowCondiments);
    }
  };

  return {
    isShowCondiments,
    showCondiments,
  };
};

export default useViewModel;
